var map = {
	"./approvalManagement/routes.js": "1bee",
	"./guaranteeManagement/routes.js": "141e",
	"./home/routes.js": "bab3",
	"./marginManagement/routes.js": "cacf",
	"./productManagement/routes.js": "795e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "588c";